import { useEffect } from 'react';
import { StanButton } from '@/components/core-components/StanButton/StanButton';
import IconMessage from '@/assets/icons/ic-message.svg';
import IconInfoCircle from '@/assets/icons/ic-info-circle.svg';
import IconProductCollectEmails from '@/assets/icons/ic-product-collect-emails.svg';
export default function GetHelpPage() {
    useEffect(() => {
        // Type guard for Beacon's existence and type
        const beacon = (window as any).Beacon;
        if (typeof beacon === 'function') {
            beacon('navigate', '/answers');
            beacon('open');
        }
        beacon('on', 'close', () => {
            beacon('navigate', '/answers');
            beacon('reset');
        });

        return () => {
            beacon('close');
            beacon('reset');
        };
    }, []);

    const handleChatWithTeam = () => {
        // Type guard for Beacon's existence and type
        const beacon = (window as any).Beacon;
        if (typeof beacon === 'function') {
            beacon('navigate', '/ask/chat');
            beacon('open');
        }
    };

    return (
        <div className='bg-canvas flex min-h-svh items-center justify-center px-4'>
            <div className='flex max-w-xl flex-col items-center'>
                <h2 className='max-w-ask-stanley-xl mb-8 text-center'>
                    We&apos;re here to help! Chat with our team, email us or visit our Help Center
                </h2>
                <div className='flex flex-col flex-wrap justify-center gap-4 sm:flex-row'>
                    <StanButton icon={IconMessage} name='chat-with-team' color='secondary' onClick={handleChatWithTeam}>
                        Chat with Team
                    </StanButton>
                    <StanButton
                        icon={IconInfoCircle}
                        name='visit-help-center'
                        color='secondary'
                        onClick={() => {
                            window.open('https://help.stan.store', '_blank');
                        }}
                    >
                        Visit Help Center
                    </StanButton>
                    <StanButton
                        icon={IconProductCollectEmails}
                        name='email-us'
                        color='secondary'
                        onClick={() => {
                            window.location.href = 'mailto:friends@stanwith.me';
                        }}
                    >
                        Email Us
                    </StanButton>
                </div>
            </div>
        </div>
    );
}
